import { HttpParams } from '@angular/common/http';

export function appendCustomFieldParams(
  params: HttpParams,
  key: string,
  customFields: Record<string, unknown>
): HttpParams {
  if (!customFields || typeof customFields !== 'object') {
    return params;
  }

  const groupedByValues = new Map<string, { ids: string[]; values: string[] }>();

  Object.keys(customFields).forEach((fieldId: string) => {
    const fieldValues = (customFields as Record<string, any[]>)[fieldId];

    if (!Array.isArray(fieldValues)) {
      return;
    }

    const normalizedValues = fieldValues
      .filter((value) => value !== null && value !== undefined)
      .map((value) => value.toString());

    if (!normalizedValues.length) {
      return;
    }

    const groupKey = normalizedValues.join(',');

    if (!groupedByValues.has(groupKey)) {
      groupedByValues.set(groupKey, { ids: [], values: normalizedValues });
    }

    groupedByValues.get(groupKey)?.ids.push(fieldId);
  });

  if (!groupedByValues.size) {
    return params;
  }

  const mappedFilter = Array.from(groupedByValues.values())
    .map((group) => `${group.ids.join(',')}:${group.values.join(',')}`)
    .join('|');

  params = params.set(`${key}Filters`, mappedFilter);
  params = params.set('customFieldSeparators', '|:,');

  return params;
}
